import React, {Component} from 'react';
import PieChartWithTable from './PieChartWithTable';

export default class TendersVsDAValue extends Component {
    render() {
        return (
            <PieChartWithTable
                title={window.__js_dashboard.tenders_vs_da_value}
                data={this.props.data}
            />
        );
    }
}
